import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function LandingHeroSearch() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [query, setQuery] = useState('');

  const goSearch = () => {
    const q = query.trim();
    if (q) {
      localStorage.setItem(
        'searchParams',
        JSON.stringify({
          search: q,
          city: 'کل ایران',
          serviceType: 'all',
          rating: 'all',
          history: 'all',
        })
      );
      navigate(`/products?search=${encodeURIComponent(q)}`);
    } else {
      navigate('/products');
    }
  };

  return (
    <div className="mx-auto w-full max-w-xl">
      <div className="flex items-stretch overflow-hidden rounded-[2rem] border border-hairline/50 bg-card-surface/95 p-1.5 shadow-[0_16px_48px_-24px_rgba(113,75,103,0.35)] ring-1 ring-signal/[0.08] transition-shadow focus-within:border-signal/25 focus-within:shadow-[0_20px_52px_-22px_rgba(113,75,103,0.42)]">
        <div className="pointer-events-none flex items-center ps-4 text-fog">
          <svg className="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden>
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
          </svg>
        </div>
        <input
          type="text"
          inputMode="search"
          enterKeyHint="search"
          role="searchbox"
          autoComplete="off"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') goSearch();
          }}
          placeholder={t('hero.searchPlaceholder')}
          aria-label={t('hero.searchPlaceholder')}
          className="products-search-input min-w-0 flex-1 border-0 bg-transparent py-3.5 pe-2 ps-2 text-base text-ink-graphite outline-none ring-0 placeholder:text-fog focus:outline-none focus:ring-0"
        />
        <button
          type="button"
          onClick={goSearch}
          className="type-button inline-flex shrink-0 items-center gap-2 rounded-[1.35rem] bg-cta-gradient px-5 py-3 text-sm text-white shadow-[0_8px_24px_-10px_rgba(113,75,103,0.6)] outline-none transition hover:brightness-105 focus:outline-none focus-visible:ring-2 focus-visible:ring-signal/40 sm:px-6"
        >
          {t('common.search')}
        </button>
      </div>
    </div>
  );
}
